module.exports = __webpack_public_path__ + "img/f.5449b24f.jpg";